import { Checkbox, Text } from '@dixa/lib-shared-habla';
import classNames from 'classnames';
import type {
  DashboardFilterValue,
  FilterControlValue,
} from 'lib-analytics-types';
import { PropsWithClassName } from 'lib-shared-types-utils';
import { memo, useMemo } from 'react';

import styles from './analyticsFilterSelectAll.module.scss';

type AnalyticsFilterSelectAllProps = {
  selectedValues: readonly FilterControlValue[];
  visibleValues: readonly DashboardFilterValue[];
  isDisabled: boolean;
  onChange: VoidFunction;
} & PropsWithClassName;

export const AnalyticsFilterSelectAll = memo(function AnalyticsFilterSelectAll({
  className,
  selectedValues,
  visibleValues,
  isDisabled,
  onChange,
}: AnalyticsFilterSelectAllProps): JSX.Element {
  const hasSelection = selectedValues.length > 0;

  const isDeterminate = useMemo(
    () =>
      selectedValues.length === visibleValues.length &&
      visibleValues.every((item) =>
        selectedValues.some(({ value }) => value === item.value),
      ),
    [selectedValues, visibleValues],
  );

  const isIndeterminate = hasSelection && !isDeterminate;

  return (
    <label
      className={classNames(className, styles.selectAll, {
        [styles.selectAllDisabled]: isDisabled,
      })}
    >
      <Checkbox
        checked={isDeterminate}
        indeterminate={isIndeterminate}
        onChange={onChange}
        disabled={isDisabled}
      />

      <Text.Paragraph>
        {hasSelection ? 'Deselect all' : 'Select all'}
      </Text.Paragraph>
    </label>
  );
});
